import './BackButton.css';

import React from 'react';

import BackArrowIcon from './BackArrowIcon';

interface BackButtonProps {
  onClick: () => void;
  ariaLabel?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, ariaLabel = 'Go back' }) => (
  <button
    type="button"
    className="back-button"
    onClick={onClick}
    aria-label={ariaLabel}
  >
    <BackArrowIcon />
  </button>
);

export default BackButton;
